module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/JTgfHy/tc-custom/9781452131931.jpg?1740288428307",
      "alt": "This image is the cover for the book Art of I Love You"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Art of I Love You\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A valentine of a book brimming with contemporary art celebrating matters of the heart.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Flowers, hearts, doilies, chocolates, and couples holding hands are all reinvented here with a cool modern twist, creating a new visual vocabulary to express all those tender sentiments we can’t quite find the words for."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Featuring contributions by such beloved artists as Gemma Correll, Julia Rothman, Rifle Paper Co., and many more, this showcase of talent will tug at the heartstrings and delight the eyes. Chock-full of page after page of inventive ways to say “I Love You,” this little treasure will win the heart of any art lover—and the heart of that special valentine. \n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Chronicle Books\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle Books LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0